<div class="edit-area">
  <img #sourceImage [src]="safeUrl" [ngStyle]="{ 'max-height': maxEditorHeight }" />
</div>

<div class="zoom-slider">
  <button mat-icon-button (click)="zoomOut()">
    <mat-icon>zoom_out</mat-icon>
  </button>
  <input [type]="'range'" [min]="minZoom" [max]="maxZoom" [step]="zoomStep" [formControl]="zoomControl" />
  <button mat-icon-button (click)="zoomIn()">
    <mat-icon>zoom_in</mat-icon>
  </button>
</div>

<div class="toolbar-group" [class.align-start]="align === 'start'">
  @if (aspectRatios.length > 1) {
    <div class="ratio-selector-wrapper">
      <glxy-form-field class="ratio-selector" bottomSpacing="none" [horizontalLayout]="true">
        <glxy-label>{{ 'GALAXY.UPLOADER.SELECT_ASPECT' | translate }}</glxy-label>
        <mat-select [formControl]="aspectControl">
          @for (aspect of aspectRatios; track aspect) {
            <mat-option [value]="aspect.value">
              {{ aspect.label }}
            </mat-option>
          }
        </mat-select>
      </glxy-form-field>
    </div>
  }

  <div class="editor-actions">
    <button mat-flat-button [color]="'primary'" (click)="onClose(true)">
      {{ 'GALAXY.UPLOADER.SAVE' | translate }}
    </button>
    <button mat-stroked-button (click)="onClose()">
      {{ 'GALAXY.UPLOADER.CANCEL' | translate }}
    </button>
  </div>

  @if (isDisabled) {
    <glxy-loading-spinner [size]="'default'" [fullWidth]="true" [fullHeight]="true" />
  }
</div>
